import React, { useEffect, useState, useRef } from 'react';
import { useForm, Controller } from "react-hook-form";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Modal, Button } from 'react-bootstrap';
import Datepicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment';
import axios from 'axios';
import { render } from '@testing-library/react';
import { env } from './const';
import { headers } from '../utils/common';
import { Role } from '../utils/role';
import { getRole, controls } from '../utils/common';
import * as axiosiInstance from '../utils/axiosinstace';
import { Tabs, Tab } from 'react-bootstrap-tabs';
import ListofBarns from './ListofBarns';
import $ from 'jquery';
import 'select2';
import { useTranslation, Trans } from 'react-i18next';
const FarmMaster = (props) => {
  const { t } = useTranslation(['farm', 'common']);
    const [headersobj] = useState(headers());
    function handleChangeFarm() {
        props.onChange(false);
    }
   
    const { register, handleSubmit, watch, formState: { errors },
    setValue,
    trigger,
    } = useForm({
        mode: 'onChange'
    });

    const [showResults, setShowResults] = useState(false)
    const [resultMessage, setResultMessage] = useState({});
    const onSubmit = async (data, e) => {
        e.preventDefault();
        try {
            const response = await axiosiInstance.addbarn(data);
            setShowResults(true);
            setResultMessage({
                error: false, message: response.message
            });
            e.target.reset();
        } catch (err) {
            console.log(err)
            setShowResults(true)
            setResultMessage({
                error: true, message: err.response.data.message
            });
        }
    }
    const [farmers, setFarmers] = useState([]);
    const [userOptions, setUserOptions] = useState({
        controls: 0, watermeter: 0
    });
    const onchangeHandler = async (e) => {
        e.preventDefault();
        try {
            const response = await axiosiInstance.getUserOptions(e.target.value);
            // alert(JSON.stringify(response))
            if (response.status) {

                setUserOptions(response.list[0]);
            }
        } catch (err) {
            console.log(err)
        }
    }
    const getfarmers = async () => {
        try {
            //const response = await apiInstance.getListofFarmers()
            if (getRole() === Role.Admin) {
                const response = await axiosiInstance.getListofFarmers_admin()
                setFarmers(response.list);
            }

            if (getRole() === Role.Farmer) {
                const response = await axiosiInstance.getListofFarms('undefined');
                let farmDropDown = [];
                response.list.forEach((item) => {
                    farmDropDown.push({
                        name: item.farmName,
                        id: item.farmID
                    })
                })
            }

        } catch (err) {
            setFarmers([])
            //console.log(err.message);
        }
    }
    useEffect(() => {

        getfarmers();
        $(document).ready(function() {
            $('#selectFarm').select2();
            $('#selectFarm').on('change', function(e) {
           
              setValue('farmer', e.target.value, { shouldValidate: true }); // Automatically triggers validation
           
              trigger('farmer'); // Manually trigger validation for 'selectFarm'
            });
          });
      
          // Cleanup function to remove the event listener
          return () => {
            $('#selectFarm').off('change');
          };
    }, []);
    return (
        <div className="farmMaster">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h2 class="m-0 text-dark">{t('farm:add.title')}</h2>
                </div>
            </div>
            <div className="card">
                <div class="card-body">
                    <Tabs activeHeaderStyle={{ background: 'transparent' }}>
                        <Tab label={t('farm:add.addNew')}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className='row'>
                                    <div className='col-md-8'>
                                        {showResults ? <Results key={Math.random()} message={resultMessage.message} error={resultMessage.error} /> : null}
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-5'>
                                        <div className='row'>
                                            {getRole() === Role.Admin ?
                                                <div className="col-md-10">
                                                    <div className="form-group">
                                                        <label>{t('common:select.farmer')}</label>
                                                        <select class="form-control" name="farmer" id="selectFarm"
                                                            {...register("farmer", {
                                                                required: t('forms:select.farmer'),
                                                            })}
                                                            onChange={onchangeHandler}
                                                        >
                                                            <option value="">{t('common:select.dashed')}</option>
                                                            {farmers.map(item => (
                                                                <option
                                                                    key={item.userName}
                                                                    value={item.userName}
                                                                >
                                                                    {item.farmerName}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.farmer && <span className="err-msg">{errors.farmer.message}</span>}
                                                    </div>
                                                </div>
                                                : <></>}
                                        </div>
                                        <div className="row">
                                            <div className="col-md-10">

                                                <div className="form-group">
                                                    <label htmlFor>{t('common:fields.barnName')}</label>
                                                    <input type="text" className="form-control" placeholder={t('farm:add.enterBarnName')}
                                                        name="farmName"
                                                        {...register("farmName", {
                                                            required: t('forms:enter.farmName'),
                                                            minLength: { value: 3, message: t('common:validation.nameTooShort') },
                                                            maxLength: { value: 20, message: t('common:validation.nameTooLong') }
                                                        })}
                                                    />
                                                    {errors.farmName && <span className="err-msg">{errors.farmName.message}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            (getRole() == Role.Admin && userOptions.controls == 1) ||
                                                (getRole() == Role.Farmer && controls() == 1)
                                                ?
                                                <div className="row">
                                                    <div className="col-md-5">

                                                        <div className="form-group">
                                                            <label htmlFor>{t('farm:add.numberOfFans')}</label>
                                                            <select className="form-control" name="fans" {...register("fans", { required: t('forms:select.fans') })}>
                                                                <option value="">{t('common:select.dashed')}</option>
                                                                {[...Array(24).keys()].map(n => (
                                                                    <option key={n + 1} value={n + 1}>
                                                                        {n + 1}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors.fans && <span className="err-msg">{errors.fans.message}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-5">

                                                        <div className="form-group">
                                                            <label htmlFor>{t('farm:add.numberOfCoolingPads')}</label>
                                                            <select className="form-control" name="fans" {...register("coolingPads", { required: t('forms:select.coolingPads') })}>
                                                                <option value="">{t('common:select.dashed')}</option>
                                                                {[...Array(24).keys()].map(n => (
                                                                    <option key={n + 1} value={n + 1}>
                                                                        {n + 1}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors.coolingPads && <span className="err-msg">{errors.coolingPads.message}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                                : <></>}
                                        {/* <div className='row'>
                                    {getRole() === Role.Admin ?
                                        <div className="col-md-10">
                                            <div className="form-group">
                                                <label>{t('common:select.farmer')}</label>
                                                <select class="form-control" name="farmer"
                                                    {...register("farmer", {
                                                        required: t('forms:select.farmer'),

                                                    })}
                                                >
                                                    <option value="">{t('common:select.dashed')}</option>
                                                    {farmers.map(item => (
                                                        <option
                                                            key={item.userName}
                                                            value={item.userName}
                                                        >
                                                            {item.farmerName}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.farmer && <span className="err-msg">{errors.farmer.message}</span>}
                                            </div>
                                        </div>
                                        : ""}
                                </div> */}
                                        <div className="row">
                                            <div className="col-md-10">
                                                <div className="form-group">
                                                    <label htmlFor>{t('farm:add.availableNetworks')}</label>
                                                    <input type="text" className="form-control" placeholder={t('farm:add.enterNetworkName')}
                                                        name="network"
                                                        {...register("network", {
                                                            //required: t('forms:enter.networkName'),
                                                            minLength: { value: 3, message: t('farm:validation.networkTooShort') },
                                                            maxLength: { value: 30, message: t('farm:validation.networkTooLong') }
                                                        })}
                                                    />
                                                    {errors.network && <span className="err-msg">{errors.network.message}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <input type="submit" value="Save" class="btn btn-primary newBtn" />
                                                <input type="reset" value="Reset" class="btn btn-secondary newBtn" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-7'>
                                        <h5>{t('farm:add.instructions')}</h5>
                                        <p>{t('farm:add.intro')}</p>
                                        <ul className='ul-align'>
                                            <li><Trans i18nKey="farm:add.ruleUnique" components={{ b: <strong /> }} /></li>
                                            <li>{t('farm:add.ruleDuplicate')}</li>
                                            <li>{t('farm:add.ruleFans')} </li>
                                            <li>{t('farm:add.ruleNetwork')}</li>
                                            <li>{t('farm:add.onceFilled')} <strong style={{ color: '#0654d1' }}>{t('common:actions.save')}</strong>.</li>
                                            <li>{t('farm:add.clickWord')} <strong style={{ color: '#0654d1' }}>{t('common:actions.reset')}</strong> {t('farm:add.resetHint')} </li>
                                        </ul>
                                    </div>
                                </div>

                            </form>
                        </Tab>
                        <Tab label={t('farm:list.title')}>
                            <ListofBarns></ListofBarns>
                        </Tab>
                    </Tabs>
                </div>
            </div>

        </div>

    );
}
const Results = (props) => {
    let error, classes;
    if (props.error === false) {
        error = 'Success';
        classes = 'alert alert-success alert-dismissible fade show'
    } else {
        error = 'Error!';
        classes = 'alert alert-danger alert-dismissible fade show'
    }
    return (
        <div className="results">
            <div className={classes}>
                <strong>{error}</strong> {props.message}
                <button type="button" class="close" data-dismiss="alert">&times;</button>
            </div>
        </div>
    );
}
export default FarmMaster;